import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 136px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const PlaceholderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
`;

export const ErrorWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: #999;
  text-align: center;
`;

export const ActualImage = styled.img<{
  $isLoaded: boolean;
  $enableFadeIn: boolean;
}>`
  width: 100%;
  height: 136px;
  object-fit: contain;
  border: 0;
  background: white;
  opacity: ${(props) => (props.$isLoaded ? 1 : 0)};
  transition: ${(props) =>
    props.$enableFadeIn ? "opacity 0.3s ease-in-out" : "none"};
`;
